// export const API_URL = "http://localhost:3333";
export const API_URL = "https://api.ergovale.com.br";
// export const API_URL = "http://18.222.203.113:3333";
